import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

type StatusGetPrestacionEmpleadosHogarByID = {
  status: number | null;
  statusText: string | null;
};

const useGetPrestacionEmpleadosHogarByID = () => {
  const [loadingGetPrestacionEmpleadosHogarByID, setLoadingGetPrestacionEmpleadosHogarByID] = useState(false);
  const [successGetPrestacionEmpleadosHogarByID, setSuccessGetPrestacionEmpleadosHogarByID] = useState(false);
  const [errorGetPrestacionEmpleadosHogarByID, setErrorGetPrestacionEmpleadosHogarByID] = useState<any>(null);
  const [dataGetPrestacionEmpleadosHogarByID, setDataPrestacionEmpleadosHogar] = useState<any>(null);

  const [statusGetPrestacionEmpleadosHogarByID, setStatusGetPrestacionEmpleadosHogarByID] =
    useState<StatusGetPrestacionEmpleadosHogarByID>({
      status: null,
      statusText: null
    });

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";

  const apiRecord = new record.RecordService(
    BASE_URL,
    FUNCTIONS_KEY
  );

  // GET
  const getPrestacionEmpleadosHogarByID = async (
    userId: string,
    prestacionId: string,
    id: string,
    _cb?: (data: any) => void
  ) => {
    setLoadingGetPrestacionEmpleadosHogarByID(true);
    setSuccessGetPrestacionEmpleadosHogarByID(false);
    setErrorGetPrestacionEmpleadosHogarByID(null);

    try {
      const res = await apiRecord.getCertificadoPrestacionEmpleoHogarByID(
        userId,
        prestacionId,
        id
      );

      setStatusGetPrestacionEmpleadosHogarByID({
        status: res.status,
        statusText: res.statusText ?? res.response ?? null
      });

      setSuccessGetPrestacionEmpleadosHogarByID(true);
      setDataPrestacionEmpleadosHogar(res.data);

      if (typeof _cb === "function") {
        _cb(res.data);
      }

      return res.data;

    } catch (err: any) {
      const responseData = err?.response?.data;
      const backendMessage =
        (typeof responseData === "string" ? responseData : null) ||
        responseData?.response ||
        responseData?.message ||
        err?.response?.statusText ||
        err?.message ||
        "Error";

      setStatusGetPrestacionEmpleadosHogarByID({
        status: err?.response?.status || 500,
        statusText: backendMessage
      });

      setErrorGetPrestacionEmpleadosHogarByID(err);
      console.error("Error en getPrestacionEmpleadosHogarByID:", err);

      throw err;

    } finally {
      setLoadingGetPrestacionEmpleadosHogarByID(false);
    }
  };

  return {
    getPrestacionEmpleadosHogarByID,
    loadingGetPrestacionEmpleadosHogarByID,
    successGetPrestacionEmpleadosHogarByID,
    errorGetPrestacionEmpleadosHogarByID,
    dataGetPrestacionEmpleadosHogarByID,
    statusGetPrestacionEmpleadosHogarByID
  };
};

export default useGetPrestacionEmpleadosHogarByID;
